import { Component, HostListener, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { CartService } from '../../../../shared/services/cart.service';
import { DataService } from 'src/shared/data/data.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-projects-page',
  templateUrl: './projects-page.component.html',
  styleUrls: ['./projects-page.component.scss']
})
export class ProjectsPageComponent implements OnInit {
  zoomScale: number = 1;
  maxPrice: number = 10000;
  brands: any[] = [
  ];
  selectedBrands: string[] = [];
  inStockOnly: boolean = false;
  sortOption: string = 'default';
  wishlist: any[] = [];
  selectedProduct: any = null;
  // PAGINATION
  currentPage = 1;
  itemsPerPage = 8;
  totalPages = 1;
  pages: number[] = [];
  pagedProjects: any[] = [];
  activeCategory: number | null = null;

  searchText: string = '';

  showCategories: boolean = true;
  showBrands: boolean = true;
  mobileFilterOpen: boolean = false;
  // selectedBrands: string[] = [];
  // selectedCategory: any | null = null;

  constructor(
    private meta: Meta,
    private titleService: Title,
    private http: HttpClient,
    private cartService: CartService,
    private data: DataService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  // =====================================
  // PAGE TITLE
  // =====================================

  pageTitle = [
    {
      bgImage: 'assets/img/projects-banner.jpg',
      title: 'Our Kitchen Magic Dishes'
    }
  ];

  // =====================================
  // CONTENT
  // =====================================

  projectsContent = [
    {
      subTitle: "",
      title: "Our Sangeetha Toys",
      paragraph: "Check out Our Various Toys "
    }
  ];

  // =====================================
  // VARIABLES
  // =====================================

  projects: any[] = [];

  filteredProjects: any[] = [];

  base_url = 'https://thesmilesstore.in/';

  cartItems: any[] = [];

  // selectedCategory = 'all';
  selectedCategory: any;
  projectCategories: any[] = [

    {
      id: '',
      name: 'All Items',
      active: true
    }

  ];

  // =====================================
  // ON INIT
  // =====================================

  ngOnInit(): void {



    this.titleService.setTitle(
      'Toy Collection & Featured Products | Sangeetha Toys'
    );

    this.meta.updateTag({
      name: 'description',
      content: 'Explore our exciting collection of toys including educational toys, action figures, dolls, remote control cars, puzzles, board games, and creative playsets from trusted brands.'
    });

    this.getProjectCategories();

    // this.getProjects();
    // this.applyFilters();
    this.getBrands();


    this.route.queryParams.subscribe(params => {

      if (params['category']) {

        this.selectedCategory = params['category'];

        this.selectCategory(this.selectedCategory);

      }

      else {
        this.getProjects();
      }

    });

  }

  // =====================================
  // GET PROJECT CATEGORIES
  // =====================================

  getProjectCategories(): void {

    this.http.post<any>(

      this.data.base_url + 'category_data/',
      {}

    ).subscribe({

      next: (response) => {

        if (response.status == 1) {

          const categories = response.data.map(
            (item: any) => {

              return {

                id: item.category_id,
                name: item.category_name,
                active: false

              };

            }
          );

          this.projectCategories = [

            {
              id: '',
              name: 'All Items',
              active: true
            },

            ...categories

          ];

        }

      },

      error: (error) => {

        console.log(error);

      }

    });

  }

  // =====================================
  // GET PROJECTS
  // =====================================

  getProjects(category?: string): void {

    const payload = category && category !== '' && category !== 'all'
      ? { category: category }
      : {};

    console.log('📤 Sending payload to backend:', payload);

    this.http.post<any>(

      this.data.base_url + 'supplychain/product_data/',
      payload

    ).subscribe({

      next: (response) => {

        console.log('📥 Backend response:', response);

        if (response.status == 1 && response.data) {

          this.projects = response.data

            .filter((project: any) =>
              project.product_name &&
              project.category
            )

            .map((project: any) => {

              const category = project.category ? project.category.toLowerCase().trim() : '';

              return {

                id: project.id,

                image: project.product_image && project.product_image !== ''
                  ? project.product_image
                  : 'assets/img/bg-1.1.jpg',

                category: category,
                brand: project.brand,

                title: project.product_name,

                location: project.location,

                description: project.product_description,

                price: project.mrp || Math.floor(Math.random() * 5000) + 1000,

                quantity: 1,

                systems: this.convertSystems(
                  project.systems
                )

              };

            });

          this.filteredProjects = [...this.projects];

          this.pagedProjects = this.filteredProjects;
          this.setupPagination();
          console.log('✅ Filtered projects:', this.filteredProjects.length);
          console.log('📋 filteredProjects array:', this.filteredProjects);


        } else {

          console.warn('⚠️ No data in response or status != 1');

          this.projects = [];
          this.filteredProjects = [];

        }

      },

      error: (error) => {

        console.error('❌ Backend error:', error);

        this.projects = [];
        this.filteredProjects = [];

      }

    });

  }

  // =====================================
  // FILTER PROJECTS
  // =====================================

  filterProjects(categoryId: string): void {

    this.selectedCategory = categoryId;

    this.projectCategories.forEach(

      (cat: any) => {

        cat.active = cat.id === categoryId;

      }

    );

    console.log('🔍 Selected category:', this.selectedCategory);

    // Backend-based filtering
    this.getProjects(categoryId);

  }

  // =====================================
  // CONVERT SYSTEMS
  // =====================================

  convertSystems(systems: any): string[] {

    try {

      if (!systems) {

        return [];

      }

      if (Array.isArray(systems)) {

        return systems;

      }

      if (typeof systems === 'string') {

        if (systems.includes('[')) {

          return JSON.parse(
            systems.replace(/'/g, '"')
          );

        }

        return systems.split(',').map(
          (item: string) => item.trim()
        );

      }

      return [];

    }

    catch (e) {

      console.log(e);

      return [];

    }

  }

  // =====================================
  // PLACEHOLDER IMAGE
  // =====================================

  getPlaceholderImage(category: string): string {

    switch ((category || '').toLowerCase()) {

      case 'commercial':
        return 'assets/img/project1.jpg';

      case 'residential':
        return 'assets/img/project2.jpg';

      case 'industrial':
        return 'assets/img/project3.jpg';

      default:
        return 'assets/img/project1.jpg';

    }

  }

  // =====================================
  // IMAGE ERROR
  // =====================================

  onImageError(event: any): void {

    event.target.src = 'assets/img/project1.jpg';

  }

  // =====================================
  // QUANTITY MANAGEMENT
  // =====================================

  increaseQuantity(project: any): void {
    project.quantity++;
  }

  decreaseQuantity(project: any): void {
    if (project.quantity > 1) {
      project.quantity--;
    }
  }

  // =====================================
  // CART FUNCTIONALITY
  // =====================================

  addToCart(project: any): void {
    this.cartService.addToCart(project);

    // Reset quantity to 1 after adding to cart
    project.quantity = 1;

    console.log('Item added to cart:', project);
  }



  scrollToCategory(id: number) {
    const el = document.getElementById('cat-' + id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.activeCategory = id;
    }
  }

  getProjectsByCategory(catId: number) {
    return this.projects.filter(p => p.category_id === catId);
  }



  @HostListener('window:scroll', [])
  onWindowScroll() {
    for (let category of this.projectCategories) {
      const el = document.getElementById('cat-' + category.id);
      if (el) {
        const rect = el.getBoundingClientRect();
        if (rect.top <= 150 && rect.bottom >= 150) {
          this.activeCategory = category.id;
        }
      }
    }
  }


  // applyFilters(): void {

  //   let data = [...this.projects];

  //   // PRICE
  //   data = data.filter(
  //     x => Number(x.price) <= this.maxPrice
  //   );

  //   // STOCK
  //   if (this.inStockOnly) {

  //     data = data.filter(
  //       x => x.stock !== 0
  //     );

  //   }

  //   console.log("selectedbrands",this.selectedBrands);
  //   console.log("data",data)
  //   // BRAND
  //   if (this.selectedBrands.length > 0) {

  //     data = data.filter(
  //       x => this.selectedBrands.includes(x.brand)
  //     );

  //   }

  //   this.filteredProjects = data;

  //   this.sortProducts();

  //   this.setupPagination();
  // }

  sortProducts(): void {

    switch (this.sortOption) {

      case 'lowToHigh':

        this.filteredProjects.sort(
          (a, b) => Number(a.price) - Number(b.price)
        );

        break;

      case 'highToLow':

        this.filteredProjects.sort(
          (a, b) => Number(b.price) - Number(a.price)
        );

        break;

      case 'nameAsc':

        this.filteredProjects.sort(
          (a, b) => a.title.localeCompare(b.title)
        );

        break;

      case 'nameDesc':

        this.filteredProjects.sort(
          (a, b) => b.title.localeCompare(a.title)
        );

        break;
      // default:

      //   this.filteredProjects = [...this.originalProjects];

      //   break;

    }

    this.setupPagination();
  }


  // toggleBrand(event: any, brand: string): void {

  //   if (event.target.checked) {

  //     this.selectedBrands.push(brand);

  //   } else {

  //     this.selectedBrands =
  //       this.selectedBrands.filter(x => x !== brand);

  //   }

  //   this.applyFilters();
  // }

  openQuickView(project: any): void {

    this.selectedProduct = project;

  }

  // toggleWishlist(project: any): void {

  //   const exists = this.wishlist.find(
  //     x => x.id === project.id
  //   );

  //   if (exists) {

  //     this.wishlist =
  //       this.wishlist.filter(x => x.id !== project.id);

  //   } else {

  //     this.wishlist.push(project);

  //     console.log("wishlist",this.wishlist);

  //   }

  // }


  toggleWishlist(project: any): void {

    const customerId = localStorage.getItem('customer_id');

    this.http.post<any>(
      this.data.base_url + 'toggle_wishlist/',
      {
        customer_id: customerId,
        product_id: project.id
      }
    ).subscribe({

      next: (res) => {

        if (res.status === 1) {

          project.isWishlist = !project.isWishlist;

          this.loadWishlistCount();
         
          if (res.action === 'added') {
          
            Swal.fire({
              toast: true,
              position: 'top-end',
              icon: 'success',
              title: `Added to Wishlist`,
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
              customClass: {
                popup: 'cart-toast',
                title: 'cart-toast-title'
              }
            });
          }
          else if (res.action === 'removed') {
            Swal.fire({
              toast: true,
              position: 'top-end',
              icon: 'success',
              title: `Removed from Wishlist`,
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
              customClass: {
                popup: 'cart-toast',
                title: 'cart-toast-title'
              }
            });
          }

        }

      },

      error: (err) => {
        console.error(err);
      }

    });

  }

  loadWishlistCount(): void {

    const customerId = localStorage.getItem('customer_id');

    this.http.post<any>(
      this.data.base_url + 'get_wishlist/',
      {
        customer_id: customerId
      }
    ).subscribe(res => {

      if (res.status === 1) {
        this.cartService.setCount(
          res.data.length
        );
      }

    });

  }

  setupPagination(): void {

    this.totalPages = Math.ceil(
      this.filteredProjects.length / this.itemsPerPage
    );

    this.pages = Array(
      this.totalPages
    ).fill(0).map((x, i) => i + 1);

    this.changePage(1);
  }

  changePage(page: number): void {

    if (page < 1 || page > this.totalPages) {
      return;
    }

    this.currentPage = page;

    const start =
      (page - 1) * this.itemsPerPage;

    const end =
      start + this.itemsPerPage;

    this.pagedProjects =
      this.filteredProjects.slice(start, end);

  }


  getBrands(): void {

    this.http.post<any>(this.base_url + "supplychain/brand_data/", {}).subscribe({
      next: (response: any) => {
        this.brands = response.data;
      }
    })

  }


  selectCategory(categoryId: any): void {

    this.selectedCategory = categoryId;

    this.applyFilters();
    this.filterProjects(categoryId);

  }

  clearAllFilters(): void {

    this.searchText = '';

    this.selectedBrands = [];

    this.selectedCategory = null;

    this.maxPrice = 10000;

    this.inStockOnly = false;

    this.applyFilters();
    this.getProjects();

  }

  applyFilters(): void {

    this.filteredProjects = this.projects.filter(product => {

      const matchesSearch =
        !this.searchText ||
        product.title?.toLowerCase().includes(this.searchText.toLowerCase()) ||
        product.description?.toLowerCase().includes(this.searchText.toLowerCase());

      const matchesCategory =
        !this.selectedCategory ||
        product.category_id === this.selectedCategory;

      const matchesBrand =
        this.selectedBrands.length === 0 ||
        this.selectedBrands.includes(product.brand);

      const matchesPrice =
        Number(product.price) <= this.maxPrice;

      const matchesStock =
        !this.inStockOnly ||
        product.stock > 0;

      return (
        matchesSearch &&
        matchesCategory &&
        matchesBrand &&
        matchesPrice &&
        matchesStock
      );

    });

    this.pagedProjects = this.filteredProjects;

    // this.updatePagination();

  }


  toggleBrand(event: any, brand: string): void {

    if (event.target.checked) {

      this.selectedBrands.push(brand);

    } else {

      this.selectedBrands =
        this.selectedBrands.filter(
          x => x !== brand
        );

    }

    this.applyFilters();

  }

  toggleCategories() {
    this.showCategories = !this.showCategories;
  }

  toggleBrands() {
    this.showBrands = !this.showBrands;
  }

  openProduct(id: string): void {
    this.router.navigate(
      ['/product-details', id]
    );
  }

}